import ScrollReveal from "scrollreveal";

export default {
  init() {
    // JavaScript to be fired on all pages.

    // Define debounce function for scroll events.
    function debounce(callback, wait, context = this) {
      let timeout       = null,
          callbackArgs  = null;

      const later = () => callback.apply(context, callbackArgs);

      return function() {
        callbackArgs = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    // Scroll events.
    $(window)
      .on('scroll', () => {
        // Shrink navbar on scroll.
        $('.banner').toggleClass('shrunk', $(window).scrollTop() > 83);
      })
      .on('scroll', debounce(() => {
        // Pause autoplayed videos outside of viewport, resume when in viewport.
        $('video[autoplay]').each(function() {
          let $video      = $(this),
              videoTop    = $video.offset().top,
              videoBottom = videoTop + $video.height(),
              viewTop     = $(window).scrollTop(),
              viewBottom  = viewTop + $(window).height();

          if (videoTop < viewBottom + 100 && videoBottom > viewTop - 100) {
            $video[0].play();
          } else {
            $video[0].pause();
          }
        });
      }, 100));

    // Handle language selector animation.
    $('.languages a').click(() => {
      $('.languages a').toggleClass('active');
    });

    // Add handy link to WP admin bar for testing RMD West.
    if ($('#wp-admin-bar-root-default').length) {
      let $a              = $('<a class="ab-item" href="#">Test RMD West <span class="rmd-west-only">(on)</span></a>'),
          $li             = $('<li id="wp-admin-bar-rmd-west">').append($a),
          origWestEnabled = $('body').is('.rmd-west'),
          updateWestEnabled = () => {
            let enabled = 'true' === localStorage.getItem('rmdWestEnabled') || origWestEnabled;

            $('body')
              .toggleClass('rmd-east', !enabled)
              .toggleClass('rmd-west', enabled);
          };

      $a.on('click', () => {
        let $westEnabled = localStorage.getItem('rmdWestEnabled');

        $westEnabled = 'true' === $westEnabled ? 'false' : 'true';
        localStorage.setItem('rmdWestEnabled', $westEnabled);
        updateWestEnabled();

        return false;
      });

      $('#wp-admin-bar-root-default').append($li);
      updateWestEnabled();
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Initialize ScrollReveal.
    const sr          = ScrollReveal(),
          optsStyleFadeUp = {
            duration: 800,
            delay: 200,
            distance: '3rem',
            scale: 1,
            easing: 'ease-in-out',
            mobile: false,
          },
          optsStyleFadeLeft = {
            duration: 800,
            delay: 200,
            distance: '3rem',
            origin: 'left',
            scale: 1,
            easing: 'ease-in-out',
            mobile: false,
          },
          optsStyleFadeRight = {
            duration: 800,
            delay: 200,
            distance: '3rem',
            origin: 'right',
            scale: 1,
            easing: 'ease-in-out',
            mobile: false,
          },
          optsReveal  = {
            viewOffset: { top: 35, right: 0, bottom: 35, left: 0 },
          },
          optsReset   = {
            reset: true,
            viewOffset: { top: 0, right: 10000, bottom: 0, left: 0 },
            afterReset: function(el) {
              $(el).addClass('invisible');
            },
          },
          isMobile    = () => window.innerWidth < 768,
          isMobileBrowser = sr.tools.isMobile;

    sr.tools.isMobile = isMobile;

    $('.reveal-section').each((index, el) => {
      sr.reveal(
        $('.reveal-fade-up', el),
        $.extend({}, optsStyleFadeUp, optsReveal),
        50
      );
      sr.reveal(
        $('.reveal-fade-left', el),
        $.extend({}, optsStyleFadeLeft, optsReveal)
      );
      sr.reveal(
        $('.reveal-fade-right', el),
        $.extend({}, optsStyleFadeRight, optsReveal)
      );
    });

    // Handle video play buttons.
    $('.play-video').on('click', function(e) {
      const $section  = $(this).closest('section'),
            vid       = $('video', $section)[0];

      sr.reveal(
        $('.reveal-fade-up', $section),
        $.extend({}, optsStyleFadeUp, { distance: '-' + optsStyleFadeUp.distance }, optsReset),
        150
      );

      $section.addClass('playing-video');
      vid.controls = true;
      vid.play();
      e.preventDefault();
    });

    // Enable smooth scrolling.
    let scrollSettings = {
      duration: 800,
      offset: { left: 0, top: -67 },
      interrupt: !isMobileBrowser(),
    };

    // Exclude Bootstrap component activation (tabs are handled manually below).
    $.localScroll(
      $.extend({}, scrollSettings, {
        filter: function() { return !$(this).is('[data-toggle]'); },
      })
    );

    // When activating a page tab, sync ScrollReveal & manually scroll to
    // activated tab pane. Also activate any duplicate navs on the page.
    $('.nav-page-tabs [data-toggle="tab"]').on('shown.bs.tab', function() {
      let target = $(this).attr('href');
      sr.sync();
      $.scrollTo(target, scrollSettings);
      $(`[data-toggle="tab"][href="${target}"]`).not(this).tab('show');
    });

    // Active page tab provided in URL hash if a match is found.
    let $tab = $(location.hash);
    if ($tab.is('.tab-pane')) {
      $('#' + $tab.attr('aria-labelledby')).tab('show');
    }

    if ($('body').hasClass('rmd-west')) {
      $('.west-contact-coupon').show();
      $('.east-contact-coupon').hide();
    } else {
      $('.west-contact-coupon').hide();
      $('.east-contact-coupon').show();
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js